import { useEffect, useRef } from 'react'
import clsx from 'clsx'

import styles from './DetailsEditor.module.scss'

interface EditableHTMLProps {
    value: string
    onChange: (value: string) => void
    className?: string
    placeholder?: string
}

export const DetailsEditor = ({ value, onChange, className, placeholder }: EditableHTMLProps) => {
    const divRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        if (divRef.current && divRef.current.innerHTML !== value) {
            const currentText = divRef.current.innerHTML
            if (currentText !== value) {
                divRef.current.innerHTML = value
            }
        }
    }, [value])

    const handleInput = () => {
        if (divRef.current) {
            const newValue = divRef.current.innerHTML
            onChange(newValue)
        }
    }

    return (
        <div
            ref={divRef}
            className={clsx(styles.root, className)}
            contentEditable
            onInput={handleInput}
            onBlur={handleInput}
            data-placeholder={placeholder}
            suppressContentEditableWarning={true}
        />
    )
}
